// extracted by mini-css-extract-plugin
export var chip = "_eg-0";
export var filterDropdown = "_eg-5";
export var filterItem = "_eg-6";
export var icon = "_eg-1";
export var removeButton = "_eg-3";
export var removeIcon = "_eg-4";
export var separator = "_eg-2";